import Account from "./Account";
import Admin from "./Admin";
import Auths from "./Auths/Route";
import BQStore from "./BQStore";
import Calendar from "./Calendar/routes";
import Canteen from "./Canteen";
// import Chat from "./Chat/routes";
import FD from "./FD";

import Home from "./Home/Route";
// import timeline from "./timeline/routes";
import letter from "./Letter";
import User from "./User/Route";

import Wpn from "./Wpn/Routes";
import WpnReports from "./Wpn/Reports/Routes";
// import errors from "./errors/routes";

import ParadeState from "./ParadeState";
import Property from "./Property";

import Settings from "./Settings";
import Leave from "./Leave";
import Company from "./Company";
import RP from "./RP";
import FileArchive from "./FileArchive/Routes";
import Applications from "./Applications/Routes";
import Allowance from "./Allowance";
import Publish from "./Publish";
import Duty from "./Duty";

import Complaint from "./Complaint/Route";
import RationReturn from "./RationReturn";
import Ration from "./Ration";
import Store from "./Store";

import HRM from "./HRM";
// import NotFound from "./NotFound/Route";
// import Notifications from "./Notifications/Routes";

import Vehicle from "./Vehicle";
import SheetRoll from "./User/SheetRoll/Route";
import Training from "./Training";

import Conversations from "./Conversation/Routes";
import SourceMany from "./SourceMany/Routes";
import Criminal from "./Criminal/Routes";

export default [
    ...Account,
    ...Admin,
    ...Allowance,
    ...Applications,
    ...Auths,
    ...BQStore,
    ...Canteen,
    // ...Chat,
    ...Calendar,
    ...Company,
    ...Complaint,
    ...Duty,
    // ...errors,
    ...FD,
    ...FileArchive,
    ...HRM,
    ...Home,
    ...Leave,
    // ...timeline,
    ...letter,
    // ...NotFound,
    // ...Notifications,
    ...ParadeState,
    ...Property,
    ...Publish,
    ...RationReturn,
    ...Ration,
    ...RP,
    ...Settings,
    ...SheetRoll,
    ...Store,
    ...Training,
    ...User,
    ...Vehicle,
    ...Wpn,
    ...WpnReports,

    // ...Conversations,
    ...SourceMany,
    ...Criminal,
];
